<template>
  <div class="hello">
    <el-container style="height: 100%; border: 1px solid #eee">
      <el-header style="text-align: right; font-size: 12px;height: 60px; padding: 0px;">
        <!-- <span>408</span> -->
        <div style="display: flex;">
          <div class="headerStyle">
            F-Lab</div>
          <el-menu :default-active="activeIndex" class="el-menu-demo HeaderNavClass" mode="horizontal">
            <template v-for="Nav in  NavList">
              <el-menu-item v-if="Nav.children !== undefined && Nav.children.length == 0" :index=Nav.index
                class="MenuClass" @click="MenuClick(Nav.url, Nav.index)">
                {{ Nav.NavName }}
              </el-menu-item>
              <el-submenu v-else :index=Nav.index>
                <template slot="title">{{ Nav.NavName }}</template>
                <el-menu-item v-for="NavCh in Nav.children" :key="index" :index=NavCh.index>
                  <!-- {{ NavCh.NavName }} -->
                  <el-menu-item v-if="NavCh.children !== undefined && NavCh.children.length == 0" :index=NavCh.index
                    @click="MenuClick(NavCh.url)">
                    {{ NavCh.NavName }}
                  </el-menu-item>

                  <el-submenu v-else :index=NavCh.index>
                    <template slot="title">{{ NavCh.NavName }}</template>
                    <el-menu-item v-for="NavChCh in NavCh.children" :key="index" :index=NavChCh.index
                      @click="MenuClick(NavChCh.url, NavChCh.index)">{{ NavChCh.NavName }}</el-menu-item>
                  </el-submenu>

                </el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </div>
      </el-header>
      <el-container style="height: calc(100% - 60px);">
        <iframe style="width: 100%;height: 100%;border: 0px;" :src=IframeSrc></iframe>
        <!-- <router-view></router-view> -->
      </el-container>
    </el-container>

  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      activeIndex: 1,
      detailWidth: 3,
      AsideWidth: 300,
      SegmentClickFlag: false,
      SegmentStartX: 0,
      NavList: [
        {
          index: 1,
          NavName: 'Introduction',
          url: './static/IntroductionWeb/home.html',
          children: []
        },
        {
          index: 2,
          NavName: 'Newsroom',
          url: 'http://f-lab.ncepu.edu.cn/wordpress',
          children: [
          ]
        },
        // {
        //   index: 3,
        //   NavName: 'Classroom',
        //   url: 'http://f-lab.ncepu.edu.cn/ai_classroom',
        //   children: []
        // },
        // {
        //   index: 4,
        //   NavName: 'Works',
        //   url: './static/WorkListWeb/home.html',
        //   children: [
        //   ]
        // },
        // {
        //   index: 5,
        //   NavName: 'Member',
        //   url: './static/MemberWeb/home.html',
        //   children: []
        // },
      ],
      URLID: [
        {
          index: 1,
          NavName: 'NILMTHDA',
          url: './static/NILMTHDAWeb/home.html',
        },
      ],
      IframeSrc: './static/IntroductionWeb/home.html'
    }
  },

  methods: {
    dragControllerDiv() {
      // 保留this引用
      let data = this;
      let resize = document.getElementById("set_menu_width");
      resize.onmousedown = function (e) {
        // 颜色改变提醒
        resize.style.background = "#67c23a";
        let startX = e.clientX;
        resize.left = resize.offsetLeft;
        document.onmousemove = function (e) {
          // 计算并应用位移量
          let endX = e.clientX;
          let moveLen = endX - startX;
          startX = endX;
          data.AsideWidth += moveLen
        };
        document.onmouseup = function () {
          // 颜色恢复
          resize.style.background = "";
          document.onmousemove = null;
          document.onmouseup = null;
        };
        this.testMethod();
      };
    },
    testMethod() {
      console.log("213")
    },
    MenuClick(url, index) {
      console.log('index: ', index)
      // this.activeIndex = index // We will rely on router/watch for this if index=1
      if (index == 1) {
        this.IframeSrc = url
        this.$router.push({ query: { id: index } })
      }
      else if (index == 2) {
        this.activeIndex = index // Still set manually for external links since they don't update our route
        window.location.href = url
      }
      else if (index == 3) {
        this.activeIndex = index // Still set manually for external links
        window.location.href = url
      }

      // this.$router.push({ name: 'HelloWorld', query: { id: index, UrlID: 0 } })
    },
    initMenu() {
      var id = this.$route.query.id
      var UrlIDIndex = this.$route.query.UrlID
      console.log("initMenu - id", id, "UrlIDIndex", UrlIDIndex)
      if (id == undefined) {
        this.activeIndex = 1
        this.IframeSrc = './static/IntroductionWeb/home.html'
      }
      else {
        var objList = this.NavList.filter((item, index, arr) => item.index == id)
        this.activeIndex = id - 0;
        if (objList.length > 0) {
          if (UrlIDIndex == 0 || UrlIDIndex == undefined) {
            this.IframeSrc = objList[0].url
          }
          else {
            var urlObjList = this.URLID.filter((item, index, arr) => item.index == UrlIDIndex)
            if (urlObjList.length > 0) {
              this.IframeSrc = urlObjList[0].url
            }
          }
        }
      }
    }
  },
  mounted() {
    this.dragControllerDiv();
  },
  created() {
    this.initMenu()
  },
  watch: {
    '$route'() {
      this.initMenu()
    }
  }
}
window.onresize = function () {
  console.log("resize")
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 手机 */
@media screen and (max-width:600px) {
  .headerStyle {
    width: 100px;
    text-align: center;
    font-size: 25px;
    font-family: 'Times New Roman', Times, serif;
    background-color: #fff;
    color: #909399;
  }

  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }

  .el-aside {
    color: #333;
  }

  .hello {
    /* background-color: antiquewhite; */
    height: 100%;
  }

  .SegmentClass {
    display: block;
    width: 25px;
    background-color: #8c95b0;
    height: 100%;
  }

  >>>.HeaderNavClass {
    margin: 0 auto;
    width: calc(100% - 100px);
    padding: 0px;
  }

  >>>.MenuClass {
    font-size: 2.2vw;
    font-family: 'Times New Roman', Times, serif;
  }
}

/* PC */
@media screen and (min-width:960px) {

  .headerStyle {
    width: 150px;
    text-align: center;
    font-size: 25px;
    font-family: 'Times New Roman', Times, serif;
    background-color: #fff;
    color: #909399;
  }

  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }

  .el-aside {
    color: #333;
  }

  .hello {
    /* background-color: antiquewhite; */
    height: 100%;
  }

  .SegmentClass {
    display: block;
    width: 25px;
    background-color: #8c95b0;
    height: 100%;
  }

  >>>.HeaderNavClass {
    margin: 0 auto;
    width: calc(100% - 150px);
    padding: 0px;
  }

  >>>.MenuClass {
    font-size: 1vw;
    font-family: 'Times New Roman', Times, serif;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue